import { Flame, Crown, BadgeCheck, Heart } from "lucide-react";
import { useLang } from "../i18n";

// Serie Presenze: il livello equivale ai giorni di presenza sul sito (1 = 1 giorno … 100 = 100 giorni).
// Colori, alone luminoso ed effetti crescono in escalation fino al 100 (leggendario).
export const BADGES = [
  { at: 1,   icon: Flame, color: "#8A8F96", glow: 3,  fx: "", key: "t1" },
  { at: 5,   icon: Flame, color: "#7DD87D", glow: 4,  fx: "", key: "t5" },
  { at: 10,  icon: Flame, color: "#34C759", glow: 5,  fx: "", key: "t10" },
  { at: 20,  icon: Flame, color: "#00A3FF", glow: 6,  fx: "", key: "t20" },
  { at: 30,  icon: Flame, color: "#33C7DD", glow: 7,  fx: "badge-fx-pulse", key: "t30" },
  { at: 40,  icon: Flame, color: "#B98CFF", glow: 8,  fx: "badge-fx-pulse", key: "t40" },
  { at: 50,  icon: Flame, color: "#FF5C00", glow: 10, fx: "badge-fx-pulse", key: "t50" },
  { at: 65,  icon: Flame, color: "#FF3B30", glow: 12, fx: "badge-fx-blaze", key: "t65" },
  { at: 80,  icon: Flame, color: "#FF2D78", glow: 14, fx: "badge-fx-blaze", key: "t80" },
  { at: 90,  icon: Flame, color: "#FFB300", glow: 16, fx: "badge-fx-blaze", key: "t90" },
  { at: 100, icon: Crown, color: "#FFD700", glow: 22, fx: "badge-fx-legend", key: "t100" },
];

export const badgeLevel = (visits) => Math.min(Math.max(visits || 0, 0), 100);

export const currentBadge = (visits) => [...BADGES].reverse().find((b) => (visits || 0) >= b.at) || null;

export const nextBadge = (visits) => BADGES.find((b) => (visits || 0) < b.at) || null;

export function BadgeIcon({ visits, size = "w-3.5 h-3.5", testid }) {
  const { t } = useLang();
  const badge = currentBadge(visits);
  if (!badge) return null;
  const Icon = badge.icon;
  const level = badgeLevel(visits);
  return (
    <span
      className={`inline-flex items-center shrink-0 ${badge.fx}`}
      style={{ color: badge.color, filter: `drop-shadow(0 0 ${badge.glow}px ${badge.color}99)` }}
      data-testid={testid}
      title={`${t(`badge.${badge.key}`)} — ${t("badge.day", { n: level })}`}
    >
      <Icon className={size} />
    </span>
  );
}

export function BadgeName({ visits, testid }) {
  const { t } = useLang();
  const badge = currentBadge(visits);
  if (!badge) return null;
  return (
    <span
      className={`font-mono text-[9px] uppercase tracking-[0.15em] font-bold shrink-0 ${badge.fx ? "" : ""}`}
      style={{ color: badge.color, textShadow: `0 0 8px ${badge.color}66` }}
      data-testid={testid}
    >
      {t(`badge.${badge.key}`)}
    </span>
  );
}


export function SubBadge({ tier, testid, variant = "compact" }) {
  const { t } = useLang();
  if (!tier) return <BadgeCheck className="w-3.5 h-3.5 text-wardogs shrink-0" data-testid={testid} />;
  const n = Math.max(1, parseInt(tier, 10) / 1000);
  if (variant === "full") {
    return (
      <span
        className="chamfer-sm border border-[#9146FF]/60 bg-[#9146FF]/10 px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-[#BF94FF] inline-flex items-center gap-1.5 shrink-0"
        style={{ boxShadow: "0 0 12px #9146FF33" }}
        title={t("sub.title", { n })}
        data-testid={testid}
      >
        <BadgeCheck className="w-3.5 h-3.5" />
        {t("sub.full", { n })}
      </span>
    );
  }
  return (
    <span
      className="chamfer-sm border border-[#9146FF]/60 bg-[#9146FF]/15 px-1.5 py-px font-mono text-[9px] font-bold text-[#BF94FF] shrink-0"
      title={t("sub.title", { n })}
      data-testid={testid}
    >
      SUB&nbsp;T{n}
    </span>
  );
}

// Distintivo dorato per chi ha donato — visibile in registro, profilo e pagina operatore.
export function DonorBadge({ size = "w-3.5 h-3.5", testid }) {
  const { t } = useLang();
  return (
    <span
      className="inline-flex items-center shrink-0 badge-fx-pulse"
      style={{ color: "#FFD700", filter: "drop-shadow(0 0 6px #FFD70099)" }}
      data-testid={testid}
      title={t("badge.donor")}
    >
      <Heart className={size} fill="#FFD700" />
    </span>
  );
}
